// MessagePopup.js
import Swal from 'sweetalert2';

export function MessagePopup({ 
  message, 
  title = "", 
  icon = "info", 
  html, 
  showCloseButton, 
  showCancelButton, 
  returnFocus = false, 
  allowOutsideClick = false, 
  allowEnterKey = true, 
  showConfirmButton = true, 
  timer, 
  reverseButtons = false, 
  confirmButtonText = "OK", 
  cancelButtonText = "Cancel", 
  focusConfirm = true, 
  confirmButtonColor = "#000000", 
  cancelButtonColor = "#000000" 
}) { 
  return Swal.fire({ 
    icon: icon, 
    title: title, 
    text: message, 
    html: html, 
    showCloseButton: showCloseButton, 
    showCancelButton: showCancelButton, 
    confirmButtonText: confirmButtonText, 
    customClass: ".swal_Alert_Html", 
    showConfirmButton: showConfirmButton, 
    confirmButtonColor: confirmButtonColor, 
    cancelButtonColor: cancelButtonColor, 
    cancelButtonText: cancelButtonText, 
    returnFocus: returnFocus, 
    allowEnterKey: allowEnterKey, 
    allowOutsideClick: allowOutsideClick, 
    focusConfirm: focusConfirm, 
    timer: timer, 
    reverseButtons: reverseButtons, 
    // cancelButtonAriaLabel: 'Thumbs down' 
    // footer: '<a href="">Why do I have this issue?</a>' 
  }); 
}